import Vue from 'vue';
import VueMask from 'v-mask';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

window.Vue = require('vue').default;

Vue.component('v-select', vSelect);
Vue.component('hello-world', require('./components/HelloWorld.vue').default); 
Vue.component('job-offering-dashboard', require('./components/jobOfferingDashboard.vue').default); 
Vue.component('job-applicant-create', require('./components/applicantCreate.vue').default); 
Vue.component('job-applicant-dashboard', require('./components/applicantDashboard.vue').default); 
Vue.component('job-offering', require('./components/jobOffering.vue').default); 
Vue.component('job-offering-index', require('./components/jobOfferingIndex.vue').default); 
Vue.component('recived-job-applications', require('./components/RecivedJobApplications.vue').default); 
Vue.component('applicant-profile-print', require('./components/applicantprofileprint.vue').default);
Vue.component('job-applicant-report', require('./components/jobApplicantsReport.vue').default);
Vue.component('applicant-report-print', require('./components/jobApplicantReportPrint.vue').default);
Vue.component('applicant-summary-print', require('./components/jobApplicantSummaryPrint.vue').default);
Vue.component('applicant-follow-ups', require('./components/ApplicantFollowUps.vue').default);
Vue.use(VueMask);

const app = new Vue({
  el: '#app',
});



// WEBPACK FOOTER //
// ./src/main.js